import SearchContainer from '../components/SearchContaier'
import BookList from '../components/BookList'
import Book from '../pages/Book'
import Navbar from '../components/Navbar'
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { setLevelId, setTermId } from "../features/search/searchSlice.js"
import { useSelector, useDispatch } from 'react-redux';
import { refreshMe } from "../features/users/login"
import { GetTermByTitle } from "../features/database/terms.js"

export default function Search() {
    const [searchParams] = useSearchParams();
    const searchParamsKey = searchParams.toString();
    const hasDevParam = searchParams.get("dev") !== null;
    const hasBookParam = searchParams.has("book");
    const hasSubscriptionParam = searchParams.has("subscription");
    const selectedBookParam = searchParams.get("book");
    const hasUrlFilters = !!(searchParams.get("level") || searchParams.get("levelId") || searchParams.get("topic") || searchParams.get("topicId"));
    let dispatch = useDispatch();

    const topic = searchParams.get("topic");
    useEffect(() => {
        async function Refresh(topic, dispatch)
        {
            const selected = await GetTermByTitle(topic)
            if (selected)
                dispatch(setTermId(selected.id));
        }
        Refresh(topic, dispatch);
    }, [topic, dispatch]);

    /* Active User Refresh : Every minute */
    const accessToken = useSelector((state) => state.user.accessToken);
    const MINUTE_MS = 60000;

    useEffect(() => {
        const interval = setInterval(() => {
        
        console.log('Refresh User : Search');

        if (accessToken) {   
            refreshMe(dispatch, accessToken, null);
            console.log("User Refreshed : " + new Date().toLocaleString());
        }

        }, MINUTE_MS);

        return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
    }, [accessToken, dispatch])

    const level = searchParams.get("level");
    useEffect(() => {
        async function Refresh(level, dispatch)
        {
            const selected = await GetTermByTitle(level);
            if (selected)
                dispatch(setLevelId(selected.id));
        }
        Refresh(level, dispatch);
    }, [level, dispatch]);

    const levelId = searchParams.get("levelId");
    useEffect(() => {
        if (levelId)
            dispatch(setLevelId(levelId));
    }, [levelId, dispatch]);
    
    const topicId = searchParams.get("topicId");
    useEffect(() => {
        if (topicId)
            dispatch(setTermId(topicId));
    }, [topicId, dispatch]);
    
    useEffect(() => {
        if (hasDevParam)
        {
            console.log("devlog started")
            window.setTimeout(function() {
                console.log("devlog active")
                var loc='bookrclass://';
                if(hasBookParam){
                    loc='bookrclass://book/'+selectedBookParam + "?" + searchParamsKey;
                }
                if(hasSubscriptionParam){
                    loc='bookrclass://supscription?' + searchParamsKey;
                }
                window.location.href = loc;
            }, 1000);
        }
    }, [hasDevParam, hasBookParam, selectedBookParam, hasSubscriptionParam, searchParamsKey])

    /* Clear Filters on Load */
    useEffect(() => {
        if (!hasUrlFilters) {
            dispatch(setLevelId(0));
            dispatch(setTermId(0));
        }
    }, [dispatch, hasUrlFilters]);

    if (searchParams.get("book"))
        return(<div>
            <Navbar/>
            <Book/>
        </div>)
    return(<div>
        <Navbar hideSearch={true} hideLevelSelector={false}/>
        <SearchContainer/>
        <BookList />
    </div>)
}
